import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/plan";



class PlanService {

  change_size(data:any){
    return axios
      .post(API_URL + '/change_size', data)
      .then(response => {
        return response;
      });
  }

  editplan(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addplan(data:any) {
    console.log(data)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
 

  deleteplan(planId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+planId)
      .then(response => {
        return response.data;
      });
  }

  copyplan(planId:number) {
    //console.log(query)
    return axios
      .post(API_URL + '/copy/'+planId)
      .then(response => {
        return response.data;
      });
  }

  


  getplans(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


  getplanlookups() {
    return axios
      .get(API_URL + "/lookups" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }

  getTCDataByID(plan_id:number, lang:string) {
    return axios
      .get(API_URL + "/cardedit/" + plan_id, {
        params:{
           lang:lang
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getImage(image_path:string) {
    
    return axios
      .post(API_URL + "/getimage", {
          image_path : image_path
      })
      .then(response => {
        return response;
      });
  }

  saveImage(plan_id:number, image_name:string, image_data:string){
    
    return axios
      .post(API_URL + "/uploadparkmapimage", {
        plan_id : plan_id,
        image_name:image_name,
        image_data: image_data
      })
      .then(response => {
        return response;
      });
  }




}

export default new PlanService();